// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'

export const SignInPageWrapper = styled.div`
  align-content: flex-start;
  align-items: flex-start;
  display: flex;
  justify-content: center;
  flex: 1;
  flex-wrap: wrap;
  padding: 2em;
  overflow-y auto;
  overflow-x: hidden;

  @media (max-height: 700px) {
    padding: .5em;

    > .form-wrapper > div {
      > [class^='Form__formContainer'] {
        margin-top: 0;

        > [class^='Form__formSection'] {
          padding: 1em;
        }
      }
    }
  }

  // Amplify isn't supporting IE11 styles here so we need to.
  // I'm not a fan of this approach but I don't have control over the class names for these children.
  > .form-wrapper > div {
    position: relative;

    > [class^='Toast'] {
      background-color: #335c84;
    }

    > [class^='Form__formContainer'] > [class^='Form__formSection'] {
      background-color: #fff;

      @media (max-height: 700px) {
        margin-bottom: 0;
      }
    }
  }
`

export const ComsearchConnectVideoWrapper = styled.div`
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.15);
  flex: 1;
  margin-top: 20px; // Amplify's sign in form has this baked in.
  max-width: 650px; // matches height of sign in form assuming aspect radio of 56%.
  min-width: 515px; // forces video on to a new row
  overflow: hidden;
  padding: 1em;

  @media(min-width: 900px) {
    margin-left: 20px; // pushes video away from sign in form.
  }

  @media (max-height: 700px) {
    margin: 0 20px;

  }
`

export const IframeWrapper = styled.div`
  background-color: #ccc;
  border: 1px solid #000;
  border-radius: .25rem;
  overflow: hidden;
  position: relative;

  &::before {
    content: ' ';
    display: block;
    height: 0;
    padding-top: 56%;
    width: 100%;

    @media (max-height: 700px) {
      padding-top: 49.5%;
    }
  }

  > iframe {
    border: 0;
    bottom: 0;
    height: 100%;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
  }
`
